module.exports = __webpack_public_path__ + "img/cases-brand-yanghe-lazyload-111.5232ee1e.jpg";